module.exports = __webpack_public_path__ + "static/media/archived.8cdc8b2f.svg";